const keyFor = (name, userId) => `fluxocrm_view_${name}_${userId || "anon"}`;

export const loadViewCache = (name, userId) => {
  try {
    return JSON.parse(localStorage.getItem(keyFor(name, userId)));
  } catch {
    return null;
  }
};

export const saveViewCache = (name, userId, data) => {
  try {
    const trimmed = Array.isArray(data) ? data.slice(0, 500) : data;
    localStorage.setItem(keyFor(name, userId), JSON.stringify(trimmed));
  } catch (e) {
    console.warn("Cache de visualização não salvo (quota do storage?):", e);
  }
};
